import { Grid, InputAdornment, Icon } from '@mui/material';
import MDInput from 'components/MDInput';
import { useEffect, useState, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import debounce from 'lodash.debounce';

export default function Search({ filters, setFilters }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState(searchParams.get('search') || '');

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        setFilters({ search: value });
      }, 500),
    [setFilters]
  );

  useEffect(() => {
    const newSearchParams = new URLSearchParams(searchParams);
    if (searchTerm) {
      newSearchParams.set('search', searchTerm);
    } else {
      newSearchParams.delete('search');
    }
    setSearchParams(newSearchParams);
    debouncedSearch(searchTerm);
  }, [searchTerm, setSearchParams, debouncedSearch, searchParams]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <Grid container alignItems='center'>
      <MDInput
        label='Search players'
        onChange={handleSearch}
        value={searchTerm}
        size='small'
        sx={{
          minWidth: 240,
          '& .MuiOutlinedInput-root': { borderRadius: '10px' }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <Icon sx={{ fontSize: '1rem', opacity: 0.5 }}>search</Icon>
            </InputAdornment>
          )
        }}
      />
    </Grid>
  );
}
